import dynamic from 'next/dynamic';
import React from 'react';

const ForgotPassword = dynamic(() => import('@members/pg-auth/ForgotPassword/Page'), {
  ssr: false,
});

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
